import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=ec04184e&scoped=true"
import script from "./FileSelect.vue?vue&type=script&lang=js"
export * from "./FileSelect.vue?vue&type=script&lang=js"
import style0 from "./FileSelect.vue?vue&type=style&index=0&id=ec04184e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec04184e",
  null
  
)

export default component.exports